import { styled } from '@mui/material/styles'

const Container = styled('div')(({ theme }) => ({
  width: 'auto',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  gap: theme.spacing(2),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  // Tighter side margins on small phones so content (and the header) use the
  // available width instead of being inset by 24px on each side.
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
  },
  [theme.breakpoints.up('md')]: {
    width: '100%',
    maxWidth: 1100,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    boxSizing: 'border-box',
  },
}))
export default Container
// export default withStyles(styles)(Container)
